import { render, staticRenderFns } from "./SportsListTable.vue?vue&type=template&id=5b80596c&"
import script from "./SportsListTable.vue?vue&type=script&lang=ts&"
export * from "./SportsListTable.vue?vue&type=script&lang=ts&"
import style0 from "./SportsListTable.vue?vue&type=style&index=0&id=5b80596c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports